import React, { useEffect, useRef, useState } from "react";
import UnstyledButton from "../../../presentational/UnstyledButton/UnstyledButton";
import "./SurveyInput.css";
import { SurveyFormStyle } from "../../../../types/Survey";

export interface SurveyInputProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    innerRef?: React.RefObject<HTMLInputElement>;
    variant?: SurveyFormStyle;
    onPlaceholderButtonClick?: () => void;
    onEnterPressed: () => void;
}

export default function (props: SurveyInputProps) {
    let [hidePlaceholder, setHidePlaceholder] = useState<boolean>(false);
    let [placeholderFocused, setPlaceholderFocused] = useState<boolean>(false);
    const inputRef = useRef<HTMLInputElement>(null);

    function checkForSubmission(e: React.KeyboardEvent<HTMLInputElement>): void {
        if (e.key === 'Enter') {
            props.onEnterPressed();
        }
    }

    useEffect(() => {
        if (placeholderFocused) {
            if (props.type == "file") {
                inputRef.current?.click();
            } else {
                inputRef.current?.focus();
            }
            setPlaceholderFocused(false);
        }
    }, [placeholderFocused]);

    if (props.value && !hidePlaceholder) {
        setHidePlaceholder(true);
    }

    let placeholderButtonClasses = ["survey-input-placeholder-button"];
    if (props.variant === "v2") {
        placeholderButtonClasses.push("survey-input-placeholder-button-v2");
    }
    let inputProps = Object.fromEntries(Object.entries(props).filter(([key]) => key !== 'variant' && key !== 'onPlaceholderButtonClick' && key !== 'onEnterPressed'));

    let classes = ["survey-input"];
    if (inputProps.className) {
        classes.push(inputProps.className);
    }
    if (props.variant === "v2") {
        classes.push("survey-input-v2");
    }
    if ((props.type == "date" || props.type == "time" || props.type == "datetime-local") && !hidePlaceholder) {
        classes.push("sr-only");
    }
    inputProps.className = classes.join(" ");

    return <>
    {((props.type == "date" || props.type == "time" || props.type == "datetime-local") && !hidePlaceholder) &&
        <UnstyledButton
            id={props.id}
            tabIndex={0}
            className={placeholderButtonClasses.join(" ")}
            aria-hidden="true"
            onClick={() => { setHidePlaceholder(true); setPlaceholderFocused(true); props.onPlaceholderButtonClick?.() }}
            //onFocus handler is necessary for tabbing to work without having to press the space bar to "click" the button
            onFocus={() => { setHidePlaceholder(true); setPlaceholderFocused(true); props.onPlaceholderButtonClick?.() }}>
            {props.placeholder}
        </UnstyledButton>
    }
    <input
        {...inputProps}
        ref={inputRef}
        //autofill events may only trigger input rather than change
        onInput={(e) => props.onChange?.(e as React.ChangeEvent<HTMLInputElement>)}
        //Fixes Android chrome bug where the input is focused but the date picker is not brought up
        onFocus={() => {
            if (props.type == "date" || props.type == "time" || props.type == "datetime-local") {
                inputRef.current?.click()
            }
        }}
        //after auto-filling multiple fields the input is blurred, but blur event is not trigered, so we need to use animation end to trigger it
        onAnimationEnd={(event) => {
            if (event.animationName === 'autoFillAnimation') {
                const syntheticEvent = {
                    target: event.target
                } as React.ChangeEvent<HTMLInputElement>;
                props.onChange?.(syntheticEvent);
                props.onBlur?.({ target: event.target } as React.FocusEvent<HTMLInputElement>);
            }
        }}
        onKeyUp={(e) => checkForSubmission(e)}
    />
    </>
}